import React, {useEffect, useState} from 'react'
import {Button, Card, Col, Divider, Row} from 'antd'
import apiRequest from '../hooks/ApiRequest'
import logo from '../static/images/New_logo.jpg'
import Layouts from './Layouts'
import useDownloadPdf from '../hooks/DownloadPdf'
import GroupPoliciesByBroker from './GroupingPolciyBroker'
const GlobleDebitNote = () => {
  const [data, setData] = useState([])
  const customerDetail = data[0]?.customerdetail
  const {generatePdf} = useDownloadPdf()
  useEffect(() => {
    fetchPolicyDetail()
  }, [])

  const fetchPolicyDetail = async () => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL +
          `/Policy/GetMyActivePolicies/get-my-active-policies`,
        'GET',
      )
      setData(response?.data?.policies)
    } catch (error) {
      console.error('Error fetching assigned users', error)
    } finally {
      //   setLoading(false)
    }
  }
  console.log('data', customerDetail)

  return (
    <>
      <Layouts title="Email Templates" classname="dashboard">
        <div className="body-height">
          <div className="bg-white">
            <div className="dash-bg-white">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <div className="section-top-heading">
                    <h3
                      style={{
                        color: '#0C1362',
                        fontWeight: '600',
                        fontSize: '25px',
                      }}>
                      Debit Note
                    </h3>
                  </div>
                </Col>
                <div className="btn-group-success">
                  <Button
                    className="btn-success"
                    size="default"
                    value={'submit'}
                    onClick={() =>
                      generatePdf('divToPrint', 'payment-history.pdf')
                    }>
                    Download
                  </Button>
                </div>
              </Row>
            </div>
            <div className="dash-bg-white" id="divToPrint">
              <div
                className="container-box"
                style={{
                  margin: '15px auto 0',
                  width: '100%',
                  maxWidth: '100%',
                }}>
                <div
                  id="divToPrint"
                  className="white-box-bg"
                  style={{
                    padding: '30px 15px 50px',
                    width: '100%',
                    margin: 'auto',
                  }}>
                  <div
                    style={{
                      padding: '15px 0',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'start',
                    }}>
                    <img
                      src={logo}
                      className="logo-img"
                      style={{width: '250px'}}
                    />
                    <h3
                      style={{
                        marginLeft: '125px',
                        textTransform: 'uppercase',
                        fontWeight: '800',
                        fontSize: '22px',
                      }}>
                      Debit note
                    </h3>
                  </div>
                  <div style={{padding: '10px'}}>
                    <div>
                      <h4
                        style={{
                          padding: '5px 2px',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          textTransform: 'capitalize',
                          backgroundColor: '#7bdaff',
                        }}>
                        customer detail
                      </h4>
                      <div>
                        <div>
                          <ul
                            style={{
                              padding: '5px 20px 20px 0',
                              fontSize: '14px',
                              color: '#000',
                              fontWeight: '500',
                              margin: '0',
                              listStyle: 'none',
                            }}>
                            <Row gutter={[16, 16]}>
                              <Col xs={12} sm={8} md={8} lg={12}>
                                <li>
                                  Name:{' '}
                                  {`${customerDetail?.clientfirstname} ${customerDetail?.clientsurname}`}
                                </li>
                                <li>
                                  Email: {customerDetail?.clientemailaddress}
                                </li>
                                <li>Age: {customerDetail?.clientage}</li>
                                <li>Gender: {customerDetail?.clientgender}</li>
                                <li>
                                  Mobile Number:{' '}
                                  {customerDetail?.clientcontactnumber}
                                </li>
                                <li>
                                  National Id: {customerDetail?.nationalid}
                                </li>
                              </Col>
                              <Col xs={12} sm={8} md={8} lg={12}>
                                <div style={{textAlign: 'start'}}>
                                  <ul
                                    style={{
                                      padding: '5px 0px 20px 0',
                                      fontSize: '14px',
                                      color: '#000',
                                      fontWeight: '500',
                                      margin: '0',
                                      listStyle: 'none',
                                    }}>
                                    <li>
                                      Address: {customerDetail?.clientaddress1}{' '}
                                      {customerDetail?.clientaddress2 &&
                                        `Address2: ${customerDetail?.clientaddress2}`}
                                    </li>
                                    <li>City: {customerDetail?.city}</li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{padding: '10px'}}>
                    <div>
                      <h4
                        style={{
                          padding: '5px 2px',
                          fontSize: '14px',
                          fontWeight: '800',
                          margin: '0',
                          textTransform: 'capitalize',
                          backgroundColor: '#7bdaff',
                        }}>
                        Policies detail
                      </h4>
                      <div>
                        <div>
                          <ul
                            style={{
                              padding: '5px 20px 20px 0',
                              fontSize: '14px',
                              color: '#000',
                              fontWeight: '500',
                              margin: '0',
                              listStyle: 'none',
                            }}>
                           <GroupPoliciesByBroker data={data} />
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layouts>
    </>
  )
}

export default GlobleDebitNote
